export const ProductLineTemplates = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height="16.8" width="16.8" rx="2.4" stroke="currentColor" strokeWidth="1.5" x="3.59961" y="3.6001" />
    <path
      d="M3.59961 9.6001C4.07961 9.6001 14.9996 9.6001 20.3996 9.6001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M9.59961 20.3999C9.59961 20.0913 9.59961 13.0713 9.59961 9.5999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
  </svg>
);
